import { z } from "zod";
import { ACCOUNT_STATUSES } from "../constants/account";

export const accountStatusSchema = z.enum(ACCOUNT_STATUSES);

export const adminUserSummarySchema = z.object({
  userId: z.string(),
  telegramId: z.string(),
  displayName: z.string(),
  username: z.string().nullable(),
  accountStatus: accountStatusSchema,
  createdAt: z.string(),
});

export type AdminUserSummaryDTO = z.infer<typeof adminUserSummarySchema>;

export const adminUsersListResponseSchema = z.object({
  users: z.array(adminUserSummarySchema),
});

export type AdminUsersListResponse = z.infer<typeof adminUsersListResponseSchema>;

export const updateAccountStatusRequestSchema = z.object({
  status: accountStatusSchema,
  reason: z.string().min(1).max(500),
});

export type UpdateAccountStatusRequest = z.infer<typeof updateAccountStatusRequestSchema>;

export const updateAccountStatusResponseSchema = z.object({
  userId: z.string(),
  accountStatus: accountStatusSchema,
});

export type UpdateAccountStatusResponse = z.infer<typeof updateAccountStatusResponseSchema>;
